export const BRAND_NAME = 'Victoria Dating Club'

export default Object.freeze({
  name: BRAND_NAME,
  logo: '/img/victoria/victoria-logo.png',
  authBackground: '/img/victoria/auth-bg.png',
  innerBackground: '/img/victoria/inner-bg.jpg'
})
